<template>
<div class="questionSetting">
    <div class="box" v-show="topicScore(1).type==1">
        <div class="title innerbox">单选题</div>
        <div class="setting-item innerbox flexstart">
            <div>每题<el-input v-model="score1" placeholder="" ></el-input>分</div>
            <el-button type="primary" plain @click="handleUpdate(1)">确定</el-button>
        </div>
        <div class="innerbox">共<span class="tc-blue">{{topicScore(1).num}}</span>题，<span>共<span class="tc-blue">{{topicScore(1).totalScore}}</span>分</span></div>
    </div>
    <div class="box" v-show="topicScore(2).type==2">
        <div class="title innerbox">多选题</div>
        <div class="setting-item innerbox flexstart">
            <div>每题<el-input v-model="score2" placeholder=""></el-input>分</div>
            <el-button type="primary" plain @click="handleUpdate(2)">确定</el-button>
        </div>
        <div class="innerbox">共<span class="tc-blue">{{topicScore(2).num}}</span>题，<span>共<span class="tc-blue">{{topicScore(2).totalScore}}</span>分</span></div>
    </div>
    <div class="box" v-show="topicScore(3).type==3">
        <div class="title innerbox">不定项选择题</div>
        <div class="setting-item innerbox flexstart">
            <div>每题<el-input v-model="score3" placeholder=""></el-input>分</div>
            <el-button type="primary" plain @click="handleUpdate(3)">确定</el-button>
        </div>
        <div class="innerbox">共<span class="tc-blue">{{topicScore(3).num}}</span>题，<span>共<span class="tc-blue">{{topicScore(3).totalScore}}</span>分</span></div>
    </div>
    <div class="box" v-show="topicScore(4).type==4">
        <div class="title innerbox">判断题</div>
        <div class="setting-item innerbox flexstart">
            <div>每题<el-input v-model="score4" placeholder=""></el-input>分</div>
            <el-button type="primary" plain @click="handleUpdate(4)">确定</el-button>
        </div>
        <div class="innerbox">共<span class="tc-blue">{{topicScore(4).num}}</span>题，<span>共<span class="tc-blue">{{topicScore(4).totalScore}}</span>分</span></div>
    </div>
    <div class="box" v-show="topicScore(5).type==5">
        <div class="title innerbox">填空题</div>
        <div class="setting-item innerbox flexstart">
            <div>每题<el-input v-model="score5" placeholder=""></el-input>分</div>
            <el-button type="primary" plain @click="handleUpdate(5)">确定</el-button>
        </div>
        <div class="innerbox">共<span class="tc-blue">{{topicScore(5).num}}</span>题，<span>共<span class="tc-blue">{{topicScore(5).totalScore}}</span>分</span></div>
    </div>
    <div class="box" v-show="topicScore(6).type==6">
        <div class="title innerbox">问答题</div>
        <div class="setting-item innerbox flexstart">
            <div>每题<el-input v-model="score6" placeholder=""></el-input>分</div>
            <el-button type="primary" plain @click="handleUpdate(6)">确定</el-button>
        </div>
        <div class="innerbox">共<span class="tc-blue">{{topicScore(6).num}}</span>题，<span>共<span class="tc-blue">{{topicScore(6).totalScore}}</span>分</span></div>
    </div>
    <div class="box" v-show="topicScore(7).type==7">
        <div class="title innerbox">材料题</div>
        <!--<div class="setting-item innerbox flexstart">-->
            <!--<div>每题<el-input v-model="score7" placeholder=""></el-input>分</div>-->
            <!--<el-button type="primary" plain @click="handleUpdate(7)">确定</el-button>-->
        <!--</div>-->
        <div class="innerbox">共<span class="tc-blue">{{topicScore(7).num}}</span>题，<span>共<span class="tc-blue">{{topicScore(7).totalScore}}</span>分</span></div>
    </div>
</div>
</template>

<script>
import {getExampaperQuesList} from 'api/testPaperApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'questionSetting',
    props:['dataList'],
    data() {
        return {
            score1:'',
            score2:'',
            score3:'',
            score4:'',
            score5:'',
            score6:'',
            score7:'',
            showList:[],
            setting: {
                defaut: ''
            },
            allScore:'',
        }
    },
    created(){
        this.$bus.on('showSetting',(val)=>{
            this.$nextTick(()=>{
                this.showList = JSON.parse(JSON.stringify([val]))
            })
        })
        this.$bus.on('showSettingAll',(val)=>{
            this.$nextTick(()=>{
                let arr = []
                this.dataList.forEach(item=>{
                    if(!arr.includes(item.questiontype)){
                        arr.push(item.questiontype)
                    }
                })
                this.showList = JSON.parse(JSON.stringify(arr))
            })
        })
        this.$bus.on('showSettingNum',(val)=>{
            this.$nextTick(()=>{
                let arr1 = []
                this.dataList.forEach(item=>{
                    if(item.questiontype==val){
                        arr1.push(item)
                    }
                })
                if(arr1.length>0){
                    switch (val){
                        case 1:
                            this.score1 = arr1.every(item=>item.defaultscore==arr1[0].defaultscore)?arr1[0].defaultscore:''
                            break
                        case 2:
                            this.score2 = arr1.every(item=>item.defaultscore==arr1[0].defaultscore)?arr1[0].defaultscore:''
                            break
                        case 3:
                            this.score3 = arr1.every(item=>item.defaultscore==arr1[0].defaultscore)?arr1[0].defaultscore:''
                            break
                        case 4:
                            this.score4 = arr1.every(item=>item.defaultscore==arr1[0].defaultscore)?arr1[0].defaultscore:''
                            break
                        case 5:
                            this.score5 = arr1.every(item=>item.defaultscore==arr1[0].defaultscore)?arr1[0].defaultscore:''
                            break
                        case 6:
                            this.score6 = arr1.every(item=>item.defaultscore==arr1[0].defaultscore)?arr1[0].defaultscore:''
                        case 7:
                            this.score6 = arr1.every(item=>item.defaultscore==arr1[0].defaultscore)?arr1[0].defaultscore:''
                            break
                    }
                }
                else{
                    this.score1=''
                    this.score1=''
                    this.score2=''
                    this.score3=''
                    this.score4=''
                    this.score5=''
                    this.score6=''
                    this.score7=''
                }
            })
        })
    },
    mounted() {
        // this.allScore=this.topicScore(1).totalScore+this.topicScore(2).totalScore+this.topicScore(3).totalScore+this.topicScore(4).totalScore+this.topicScore(5).totalScore+this.topicScore(6).totalScore
        // console.log(this.allScore)
    },
    methods: {
        handleUpdate(num){
            let _thisScore;
            switch(num) {
                case 1:
                    _thisScore = this.score1;
                    break;
                case 2:
                    _thisScore = this.score2;
                    break;
                case 3:
                    _thisScore = this.score3;
                    break;
                case 4:
                    _thisScore = this.score4;
                    break;
                case 5:
                    _thisScore = this.score5;
                    break;
                case 6:
                    _thisScore = this.score6;
                    break;
                case 7:
                    _thisScore = this.score7;
                    break;
                default:
                    _thisScore = this.score1;
            }
            //通知更改题型分数
            this.$bus.emit('changeTopicScore',{score:_thisScore,ind:num})
        },
        ...mapActions([
            'setLoading',
        ])
    },
    filters: {},
    watch: {
         dataList:function (val,val1) {
            if(val.length !=val1.length){
                let arr1 = [],arr2 = [],arr3 = [], arr4 = [], arr5 = [],arr6 = [],arr7 = [];
                this.dataList.forEach(item=>{
                    if(item.questiontype==1){
                        arr1.push(item)
                    }
                    if(item.questiontype==2){
                        arr2.push(item)
                    }
                    if(item.questiontype==3){
                        arr3.push(item)
                    }
                    if(item.questiontype==4){
                        arr4.push(item)
                    }
                    if(item.questiontype==5){
                        arr5.push(item)
                    }
                    if(item.questiontype==6){
                        arr6.push(item)
                    }
                    if(item.questiontype==7){
                        arr7.push(item)
                    }
                })
                if(arr1.length>0){
                    this.score1 = arr1.every(item=>item.defaultscore==arr1[0].defaultscore)?arr1[0].defaultscore:''
                }
                else{
                    this.score1 = ''
                }
                if(arr2.length>0){
                    this.score2 = arr1.every(item=>item.defaultscore==arr2[0].defaultscore)?arr2[0].defaultscore:''
                }
                else{
                    this.score2 = ''
                }
                if(arr3.length>0){
                    this.score3 = arr1.every(item=>item.defaultscore==arr3[0].defaultscore)?arr3[0].defaultscore:''
                }
                else{
                    this.score3 = ''
                }
                if(arr4.length>0){
                    this.score4 = arr1.every(item=>item.defaultscore==arr4[0].defaultscore)?arr4[0].defaultscore:''
                }
                else{
                    this.score4 = ''
                }
                if(arr5.length>0){
                    this.score5 = arr1.every(item=>item.defaultscore==arr5[0].defaultscore)?arr5[0].defaultscore:''
                }
                else{
                    this.score5 = ''
                }
                if(arr6.length>0){
                    this.score6 = arr1.every(item=>item.defaultscore==arr6[0].defaultscore)?arr6[0].defaultscore:''
                }
                else{
                    this.score6 = ''
                }
                if(arr7.length>0){
                    this.score7 = arr1.every(item=>item.defaultscore==arr7[0].defaultscore)?arr7[0].defaultscore:''
                }
                else{
                    this.score7 = ''
                }

            }
         }
    },
    computed: {
        topicScore:function () {
            return function (ind) {
                if(this.dataList.length>0){
                    let arr = this.dataList.filter((item,index)=>{
                        return item.questiontype===ind
                    });
                    let totalScore = 0,type=0;
                    arr.forEach(item=>{
                        totalScore+=Number(item.defaultscore)
                    });
                    arr.forEach(item=>{
                        type=item.questiontype
                    });
                    return {num:arr.length,score:parseInt(totalScore/arr.length),totalScore:totalScore,type:type}
                }else{
                    return {num:0,totalScore:0}
                }
            }
        },
        // showSettingList:function () {
        //     return function (val) {
        //         if(this.showList.includes(val)){
        //             return true;
        //         }else{
        //             return false
        //         }
        //     }
        // },
        ...mapGetters([

        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.questionSetting {
    .box{
        width: 360px;
        padding: 20px;
        box-sizing: border-box;
        border: 1px solid #E5E5E5 ;
        .tc-blue{
            margin: 0 5px;
        }
        .innerbox+.innerbox{
            margin-top: 20px;
        }
        .title{
            font-size: 16px;
            font-weight: 600;
        }
        .setting-item{
            .el-input{
                width: 100px;
                height: 32px;
                margin: 0 10px;
            }
            .el-button{
                min-width: 48px !important;
                height: 32px;
                margin-left: 20px;
            }
        }
    }
    .box+.box{
        margin-top: 20px;
    }
}
</style>
